import { SDKs } from "~/constants/routes";

import { SDKProps, DefaultContext } from "~/types";

import localContentDefaults from "~/sdks/LocalContent/defaultState";
import demographicsDefaults from "~/sdks/Demographics/defaultState";
import localProfilesDefaults from "~/sdks/LocalProfiles/defaultState";
import locallNeighbourhoodMapsDefaults from "~/sdks/LocalNeighbourhoodMap/defaultState";
import localNeighborhoodHeroDefaults from "~/sdks/LocalNeighborhoodHero/defaultState";
import localNeighborhoodCharacteristicsDefaults from "~/sdks/LocalNeighborhoodCharacteristics/defaultState";
import localNeighborhoodDemographicsDefaults from "~/sdks/LocalNeighborhoodDemographics/defaultState";
import localNeighborhoodHighlightsDefaults from "~/sdks/LocalNeighborhoodHighlights/defaultState";

const globalDefaults: Partial<
  DefaultContext<SDKProps>["sdkState"]["globalOptions"]
> = {
  locale: "en",
};

const defaultState: Record<
  SDKs,
  {
    globalOptions: DefaultContext<SDKProps>["sdkState"]["globalOptions"];
    options: Partial<DefaultContext<SDKProps>["sdkState"]["options"]>;
  }
> = {
  "local-content": {
    globalOptions: globalDefaults,
    options: localContentDefaults,
  },
  "local-content-google-maps": {
    globalOptions: globalDefaults,
    options: localContentDefaults,
  },
  demographics: {
    globalOptions: globalDefaults,
    options: demographicsDefaults,
  },
  "local-profiles": {
    globalOptions: globalDefaults,
    options: localProfilesDefaults,
  },
  "local-neighbourhood-map": {
    globalOptions: globalDefaults,
    options: locallNeighbourhoodMapsDefaults,
  },
  "local-neighbourhood-map-google-maps": {
    globalOptions: globalDefaults,
    options: locallNeighbourhoodMapsDefaults,
  },
  "local-neighborhood-hero": {
    globalOptions: globalDefaults,
    options: localNeighborhoodHeroDefaults,
  },
  "local-neighborhood-characteristics": {
    globalOptions: globalDefaults,
    options: localNeighborhoodCharacteristicsDefaults,
  },
  "local-neighborhood-highlights": {
    globalOptions: globalDefaults,
    options: localNeighborhoodHighlightsDefaults,
  },
  "local-neighborhood-demographics": {
    globalOptions: globalDefaults,
    options: localNeighborhoodDemographicsDefaults,
  },
};

export default defaultState;
